<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $tc("categories.pcqdsi.name", 1) }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-text-field
            clearable
            type="text"
            v-model="pcq.revision"
            :label="$t('Revision.')"
            dense
            outlined
            :rules="rules.revision"
          />
          <v-text-field
            v-model="pcq.name"
            :disabled="!isEditable"
            :rules="rules.name"
            :label="$t('commons.name')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>
          <div style="margin-bottom: 25px">
            <label>{{ $t("commons.description") }}</label>
            <ckeditor
              :editor="editor"
              :disabled="!isEditable"
              tag-name="textarea"
              rows="5"
              v-model="pcq.description"
              :config="editorConfig"
              :hint="$t('views.template.hint.description')"
              :label="$t('commons.description')"
              className="content-element"
            ></ckeditor>
          </div>
          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              v-if="!loading"
              @click="save"
              :disabled="!isEditable"
            />
            <avs-button
              v-else
              icon
              color="secondary"
              class="spin-loading"
              :iconI="loading ? 'mdi-loading spin' : ''"
              label
              fab
              small
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { PckLiner } from "@/utils/datamodels"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { pcqLinerService } from "@/services"
import { required, max64, isNumber } from "@/utils/validator"
import _ from "lodash"

export default {
  name: "PcqEditor",
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    pcq: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    },
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  data() {
    return {
      defaultItems: [],
      pcqLiner: PckLiner(),
      loading: false,
      rules: {
        description: [required],
        name: [required, max64],
        revision: [isNumber]
      },
      users: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "paragraph",
          "heading1",
          "heading2",
          "bold",
          "italic",
          "|",
          "link",
          "|",
          "undo",
          "redo",
          "-",
          "numberedList",
          "bulletedList"
        ]
      }
    }
  },
  methods: {
    getDefaultValue() {
      return this.pcqLiner
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (data.id > 0) {
        return pcqLinerService.put(data)
      } else {
        return pcqLinerService.post(this.projectId, data)
      }
    },
    async save() {
      this.loading = true

      if (this.$refs.form.validate()) {
        const response = await this.performSave(this.pcq)
        this.$emit("input", response)
        this.$emit("success")
        // try {
        //   const response = await pcqLinerService.post(this.projectId, this.pcq)
        //   this.$emit("input", response)
        //   this.$emit("success")
        //   this.loading = false
        // } catch (error) {
        //   const message = error?.external_emails
        //   this.$emit("error", message)
        //   this.loading = false
        // }
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style>
.ck.ck-editor__main > .ck-editor__editable {
  height: 200px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}

.spin-loading {
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
